import { render } from "./CustomForm.vue?vue&type=template&id=59b4a422&scoped=true"
import script from "./CustomForm.vue?vue&type=script&lang=js"
export * from "./CustomForm.vue?vue&type=script&lang=js"

import "./CustomForm.vue?vue&type=style&index=0&id=59b4a422&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b4a422"]])

export default __exports__